<div 
  *ngIf="render" 
  [ngClass]="'avano-popover'"
  [ngStyle]="style"
  [class]="styleClass"
  [class.with-separators]="childrenSeparators"
  (click)="onOverlayClick($event)"
  #container
>
  <div class="avano-popover-content">
    <div *ngIf="!contentTemplate" #contentInjectionAnchor style="display: none" class="skip-separator" ></div>
    <ng-content></ng-content>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>